import React from 'react';
import styled from 'styled-components';
import _set from 'lodash/set';

import { GoogleAnalyticsPlugin } from './plugins';

import COLORS from '@mlb/react-patterns/style/universal.color';
import Player from '@mlb/react-patterns/components/MediaPlayback/mediaPlaybackWrapper.tsx';

const Wrapper = styled(Player)`
    background-color: ${COLORS.mlbGrey7};

    video,
    .mlb-player-controls-loader--container,
    .mlb-player-controls--loader::after {
        background-color: ${COLORS.mlbGrey7} !important;
    }
`;

const PlaybackWrapper = (props) => {

    const {
        mediaConfig = {},
        playerOptions = {},
        ...otherProps
    } = props;

    const { metaData = {} } = playerOptions;
    const { keywordsDisplay = [] } = metaData;

    const mediaConfigClone = { ...mediaConfig };
    const customPlugins = [];
    const pluginConfigs = mediaConfig.pluginConfigs || [];
    const googleAnalytics = mediaConfigClone.videocore?.tracking?.googleAnalytics || {};

    customPlugins.push({
        name: 'GoogleAnalyticsPlugin',
        type: 'CUSTOM',
        pluginReference: GoogleAnalyticsPlugin,
        googleAnalytics,
    });

    mediaConfigClone.pluginConfigs = pluginConfigs.concat(customPlugins);

    const tags = keywordsDisplay.map((keyword) => keyword.slug).join(",");
    _set(mediaConfigClone, 'videocore.tracking.conviva.custom.categoryType', tags);

    return (
        <Wrapper mediaConfig={mediaConfigClone} playerOptions={playerOptions} {...otherProps} />
    );

};
export default PlaybackWrapper;
